import {Box, Typography} from '@mui/material';

import './styles';
import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import ResultScreen from '@/app/shared-components/ResultScreen/ResultScreen';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const KidCreatedContent = () => {
  const {kidData, handleDurationEnds} = useViewModelProvider();

  return (
    <ResultScreen
      imgSrc="/assets/images/etc/celebration.webp"
      title={
        <Box className="content">
          <ChangeTextWithColorAndImage
            text={`<#801DE7;${kidData.firstName}'s> account's ready! Time to request their`}
            textStyle={{
              color: '#191C1B',
              fontFamily: 'Poppins',
              fontSize: 22,
              fontStyle: 'normal',
              fontWeight: 600,
              letterSpacing: -0.22,
            }}
          />
          <Typography className="title">Modak card and get started.</Typography>
        </Box>
      }
      progressBarDuration={3200}
      onDurationEnds={handleDurationEnds}
      showConfetti
    />
  );
};

const KidCreatedPage = () => {
  return (
    <ViewModelProvider>
      <KidCreatedContent />
    </ViewModelProvider>
  );
};

export default KidCreatedPage;
